<script>
import { mapActions } from 'vuex'
import store from '@/store/index.js'
export default {
  name: 'Callback',
  // beforeRouteEnter (to, from, next) {
  //   next(vm => vm.init())
  // },
  // mounted () {
  //   window.addEventListener('pageshow', this.onPageShow)
  // },
  // beforeDestroy () {
  //   window.removeEventListener('pageshow', this.onPageShow)
  // },
  methods: {
    ...mapActions({
      getOrder: 'order/getOrder'
    })
    // onPageShow (e) {
    //   if (e.persisted) {
    //     this.init()
    //   }
    // },
    // init () {
    //   if (this.$route.query.orderSerial && this.$route.query.orderToken) {
    //     this.getOrder().then(res => {
    //       if (res.data.status === 'temp') {
    //         if (res.data.actId === 'bid2buy' && !store.getters['user/isLogin']) { // 判斷若是競價單就一定要登入，否則踢回登入頁
    //           store.dispatch('user/goLogin')
    //         } else {
    //           this.$router.replace({
    //             name: res.data.actId === 'bid2buy' ? 'OrderBid' : 'OrderDetail',
    //             query: {
    //               orderSerial: this.$route.query.orderSerial,
    //               orderToken: this.$route.query.orderToken
    //             }
    //           })
    //         }
    //       } else {
    //         this.$router.replace({
    //           name: 'OrderResult',
    //           query: {
    //             orderSerial: this.$route.query.orderSerial,
    //             orderToken: this.$route.query.orderToken
    //           }
    //         })
    //       }
    //     })
    //   } else {
    //     // MEMO: 沒有帶資料的話 應導入404頁面
    //     this.$router.replace({
    //       name: 'NotFound'
    //     })
    //   }
    // }
  },
  created () {
    if (this.$route.query.orderSerial && this.$route.query.orderToken) {
      this.getOrder().then(res => {
        if (res.data.status === 'temp') {
          if (res.data.actId === 'bid2buy' && !store.getters['user/isLogin']) { // 判斷若是競價單就一定要登入，否則踢回登入頁
            store.dispatch('user/goLogin')
          } else {
            this.$router.replace({
              name: res.data.actId === 'bid2buy' ? 'OrderBid' : 'OrderDetail',
              query: {
                orderSerial: this.$route.query.orderSerial,
                orderToken: this.$route.query.orderToken
              }
            })
          }
        } else {
          this.$router.replace({
            name: 'OrderResult',
            query: {
              orderSerial: this.$route.query.orderSerial,
              orderToken: this.$route.query.orderToken
            }
          })
        }
      })
    } else {
      // MEMO: 沒有帶資料的話 應導入404頁面
      this.$router.replace({
        name: 'NotFound'
      })
    }
  },
  render: function (h) {
    return h() // avoid warning message
  }
}
</script>
